<!--
    Notification Header

    <NotificationHeader :unread-notif-count="..." @close:menu="..."></NotificationHeader>
-->
<script setup lang="ts">
/* CONFIG */
/* COMPONENTS */
import { ALDismissButton, ALDivider } from '@af-lib/vue-ui';

import { t } from '@/config/i18n';

/* PROPS */
type Props = {
  unreadCount?: number;
};
const props = defineProps<Props>();

/* EMITS */
const emits = defineEmits<{
  (e: 'close:menu'): void;
}>();
</script>

<template>
  <!-- Sticky header -->
  <div class="bg-af-white">
    <!-- Title Menu -->
    <div class="flex h-13 items-center justify-between p-5">
      <p class="text-heading3-roboto text-text-default text-lg!" role="heading" :aria-level="3">
        {{ t('notifications.title') }}
      </p>
      <!-- Close button icon -->
      <ALDismissButton iconClass="text-lg" @click="emits('close:menu')" />
    </div>
    <ALDivider type="horizontal" />
    <!-- Banner to display unread count of notifications -->
    <!-- @todo Replace with the grey-100 token once it’s available in the design system. -->
    <div v-if="props.unreadCount !== undefined" class="flex h-13.25 items-center bg-af-grey-100 px-4">
      <p class="text-body3-light text-text-default">
        {{ t('notifications.unread_count', { notification: props.unreadCount }) }}
      </p>
    </div>
  </div>
</template>
